import { action, makeAutoObservable } from 'mobx';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { FormModel } from 'src_common/common/mobx-utils/Form2/FormModel';
import { validateNotEmpty } from 'src_common/common/mobx-utils/Form2/validators';

export type PromoCarouselTranslationFormType = {
    btn_title: null | undefined | string;
    subtitle: null | undefined | string;
    tc_text: null | undefined | string;
    title: null | undefined | string;
    language: string;
};

export class PromoCarouselTranslationsState {
    public isNewForm: boolean = true;
    public isDuplicatedForm: boolean = true;
    public readonly language: FormInputState<string, string>;
    public readonly title: FormInputState<string, string>;
    public readonly subtitle: FormInputState<string, string>;
    public readonly btnTitle: FormInputState<string, string>;
    public readonly tcText: FormInputState<string, string>;
    private readonly form: FormModel<PromoCarouselTranslationFormType>;

    constructor() {
        this.language = FormInputState.new('').map(validateNotEmpty('Please choose a language'));
        this.title = FormInputState.new('');
        this.subtitle = FormInputState.new('');
        this.btnTitle = FormInputState.new('');
        this.tcText = FormInputState.new('');

        this.form = FormModel.group({
            language: this.language,
            title: this.title,
            subtitle: this.subtitle,
            btn_title: this.btnTitle,
            tc_text: this.tcText,
        });
        makeAutoObservable(this);
    }

    getFormValue = (): PromoCarouselTranslationFormType | null => {
        this.form.setAsVisited();
        const { result } = this.form;

        if (result.value.type === 'ok') {
            return {
                ...result.value.data,
            };
        }
        return null;
    };

    @action public resetForm = (): void => {
        this.form.reset();
    };
}
